import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SearchIcon from '@mui/icons-material/Search';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { USER_ROLES } from '../../constants/userRoles';

export const HOME_CONTENT_BY_ROLE = {
  [USER_ROLES.PACIENTE]: {
    roleLabel: 'Paciente',
    intro:
      'Desde acá podés gestionar tus turnos médicos, buscar nuevas citas y consultar tu historial de atenciones.',
    features: [
      {
        Icon: CalendarMonthIcon,
        title: 'Mis Turnos',
        description: 'Consultá tus turnos confirmados, cancelá o reprogramá citas según disponibilidad.',
        to: '/turnos',
      },
      {
        Icon: SearchIcon,
        title: 'Buscar Turnos',
        description: 'Encontrá médicos, especialidades y horarios disponibles para reservar tu próxima cita.',
        to: '/buscar-turnos',
      },
      {
        Icon: MedicalServicesIcon,
        title: 'Historial',
        description: 'Revisá el registro de tus turnos anteriores y el estado de cada atención.',
        to: '/turnos/historial',
      },
    ],
  },
  [USER_ROLES.MEDICO]: {
    roleLabel: 'Médico',
    intro:
      'Configurá tu perfil profesional, administrá tus servicios y definí en qué sedes y horarios atendés pacientes.',
    features: [
      {
        Icon: CalendarMonthIcon,
        title: 'Agenda',
        description: 'Visualizá los turnos asignados a tu nombre y organizá tu jornada de atención.',
        to: '/agenda',
      },
      {
        Icon: MedicalServicesIcon,
        title: 'Servicios',
        description: 'Gestioná tus especialidades y prácticas, con duración y costo de cada consulta.',
        to: '/servicios',
      },
      {
        Icon: LocationOnIcon,
        title: 'Sedes',
        description: 'Seleccioná las sedes donde ejercés tu práctica médica dentro del sistema.',
        to: '/sedes',
      },
      {
        Icon: EventAvailableIcon,
        title: 'Disponibilidades',
        description: 'Definí los días y franjas horarias en las que estás disponible para atender.',
        to: '/disponibilidades',
      },
    ],
  },
};
